import { useEffect } from "react";
import "./style.css";
import "./responsive.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import QueryModal from "./components/QueryModal";
import Home from "./pages/home/Home";

function App() {
  useEffect(() => {
    const revealElements = (root = document) => {
      const elements = [
        ...(root.matches?.("[data-wow]:not(.wow-ready)") ? [root] : []),
        ...root.querySelectorAll("[data-wow]:not(.wow-ready)"),
      ];

      elements.forEach((element) => {
        element.classList.add("wow-ready");
        observer?.observe(element);
      });
    };

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    let observer;

    if (!prefersReducedMotion && "IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("wow-visible");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.14, rootMargin: "0px 0px -40px" },
      );
    }

    revealElements();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) revealElements(node);
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer?.disconnect();
      mutationObserver.disconnect();
      document.querySelectorAll(".wow-ready").forEach((element) => {
        element.classList.remove("wow-ready", "wow-visible");
      });
    };
  }, []);

  return (
    <div id="top">
      <Header />
      <Home />
      <Footer />
      <QueryModal />
    </div>
  );
}

export default App;
